import React, { Component } from 'react';
import { MdLogout } from 'react-icons/md';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Link } from 'react-router-dom';

export class AppBody extends Component {
  static displayName = AppBody.name;

  render () {
    return (
      <div>
        {/* <NavMenu /> */}
        <header className="signup-logo" 
        // style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "100%"}}
        >
            <Link to="/"><img src="elvna.webp" width="180px" alt="logo"></img></Link>
            {/* <button className="dashboard__logout" onClick={() => {}} style={{alignSelf: "flex-end", textAlign: "right"}}>
                Log out
                <MdLogout size={16} style={{ marginLeft: '4px' }} />
            </button> */}
        </header>
        <Container fluid="md">
          {this.props.children}
        </Container>
      </div>
    );
  }
}
